import { Form, Input, Button, Checkbox, Typography, Col } from 'antd'
import { useTranslation } from 'react-i18next'
import { useCustomisation } from '../../context/CustomisationProvider'
import FormItemPasswordProgress from './FormItemPasswordProgress'

const { Title } = Typography

const RegisterForm = ({ onSubmit }) => {
  const { t } = useTranslation()
  const { theme } = useCustomisation()
  const { registerPolicyCheckbox } = theme

  return (
    <Form
      layout="vertical"
      onFinish={onSubmit}
      requiredMark={false}
      id="register"
    >
      <Title level={2}>
        {t('Login.NewUser')}
        <br />
        <strong>{t('Login.CreateAccount')}</strong>
      </Title>
      <Form.Item
        label={t('Login.FirstName')}
        name="first_name"
        rules={[
          {
            required: true,
            message: t('Register.error.PleaseEnterFirstName'),
          },
          {
            min: 2,
            message: t('Register.error.MinFirstName'),
          },
        ]}
      >
        <Input
          tabIndex={4}
          placeholder={t('Login.FirstName.placeholder')}
          autoComplete="on"
        />
      </Form.Item>
      <Form.Item
        label={t('Login.LastName')}
        name="last_name"
        rules={[
          {
            required: true,
            message: t('Register.error.PleaseEnterLastName'),
          },
          {
            min: 2,
            message: t('Register.error.MinLastName'),
          },
        ]}
      >
        <Input
          tabIndex={5}
          placeholder={t('Login.LastName.placeholder')}
          autoComplete="on"
        />
      </Form.Item>
      <Form.Item
        name="email"
        label={t('Login.NewEmail')}
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterEmail'),
          },
          {
            type: 'email',
            message: t('Register.error.PleaseEnterValidEmail'),
          },
        ]}
        hasFeedback
      >
        <Input
          tabIndex={6}
          placeholder={t('Login.NewEmail.placeholder')}
          autoComplete="on"
        />
      </Form.Item>
      <FormItemPasswordProgress
        placeholder={t('Login.NewPassword.placeholder')}
      />
      {registerPolicyCheckbox && <br />}
      {registerPolicyCheckbox && (
        <Form.Item
          label=""
          name="policy"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error(t('Register.error.Policy'))),
            },
          ]}
        >
          <Checkbox>
            <span
              dangerouslySetInnerHTML={{
                __html: t('Login.RegisteringPrivacy'),
              }}
            ></span>
          </Checkbox>
        </Form.Item>
      )}
      <Form.Item>
        <Col xs={24} sm={14} xl={12}>
          <Button tabIndex={8} type="primary" htmlType="submit" block>
            {t('Login.Register.button')}
          </Button>
        </Col>
      </Form.Item>
    </Form>
  )
}

export default RegisterForm
